export const mutations = {
  addPays (state, pays) {
    state.pays = pays
  },
  setPays (state, pays) {
    state.pays = pays
  },
  addPayss(state, pays){
    state.payss = [ ...pays ]
  },
  addPaysPage(state, pays){
    state.payss = pays
  },
}
